<template>
  <b-row>
    <b-col>
      <b-row class="text-left">
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[0])"
            :id="testKitTests[0].name"
            v-model="testSelectedComputed"
            :name="testKitTests[0].name"
            :value="testKitTests[0]"
          >
            {{ testKitTests[0].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[1])"
            :id="testKitTests[1].name"
            v-model="testSelectedComputed"
            :name="testKitTests[1].name"
            :value="testKitTests[1]"
          >
            {{ testKitTests[1].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[2])"
            :id="testKitTests[2].name"
            v-model="testSelectedComputed"
            :name="testKitTests[2].name"
            :value="testKitTests[2]"
          >
            {{ testKitTests[2].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[3])"
            :id="testKitTests[3].name"
            v-model="testSelectedComputed"
            :name="testKitTests[3].name"
            :value="testKitTests[3]"
          >
            {{ testKitTests[3].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[4])"
            :id="testKitTests[4].name"
            v-model="testSelectedComputed"
            :name="testKitTests[4].name"
            :value="testKitTests[4]"
          >
            {{ testKitTests[4].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[5])"
            :id="testKitTests[5].name"
            v-model="testSelectedComputed"
            :name="testKitTests[5].name"
            :value="testKitTests[5]"
          >
            {{ testKitTests[5].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[6])"
            :id="testKitTests[6].name"
            v-model="testSelectedComputed"
            :name="testKitTests[6].name"
            :value="testKitTests[6]"
          >
            {{ testKitTests[6].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[7])"
            :id="testKitTests[7].name"
            v-model="testSelectedComputed"
            :name="testKitTests[7].name"
            :value="testKitTests[7]"
          >
            {{ testKitTests[7].name }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col class="col-lg-3">
          <b-form-checkbox
            v-if="checkArray(testKitTests[8])"
            :id="testKitTests[8].name"
            v-model="testSelectedComputed"
            :name="testKitTests[8].name"
            :value="testKitTests[8]"
          >
            {{ testKitTests[8].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-3">
          <b-form-checkbox
            v-if="checkArray(testKitTests[9])"
            :id="testKitTests[9].name"
            v-model="testSelectedComputed"
            :name="testKitTests[9].name"
            :value="testKitTests[9]"
          >
            {{ testKitTests[9].name }}
          </b-form-checkbox>
        </b-col>
        <b-col class="col-lg-6">
          <b-form-checkbox
            v-if="checkArray(testKitTests[10])"
            :id="testKitTests[10].name"
            v-model="testSelectedComputed"
            :name="testKitTests[10].name"
            :value="testKitTests[10]"
          >
            {{ testKitTests[10].name }}
          </b-form-checkbox>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import _ from "lodash";

export default {
  name: "TestKitTestChecklistComponent",
  props: {
    tests: {
      required: true,
    },
    testSelected: {
      required: true,
    },
  },
  computed: {
    testSelectedComputed: {
      get() {
        return this.testSelected;
      },
      set(value) {
        this.$emit("update:testSelected", value);
      },
    },
    testKitTests() {
      let tkTests = [...this.tests];
      if (tkTests.length < 11) {
        let number = 11 - tkTests.length;
        let emptyArray = new Array(number);
        tkTests = [...tkTests, ...emptyArray];
      }

      return tkTests;
    },
  },
  methods: {
    checkArray(value) {
      let boolean = !_.isUndefined(value);
      if (boolean) {
        boolean =
          value.lab_type == (this.isOutLab ? "outlab" : "inlab") ||
          value.lab_type == null;
      }
      return boolean;
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #000 !important;
}
</style>
